import React from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AdminRouteGuard } from '../components'

export const Route = createFileRoute('/admin')({
  component: () => (
    <AdminRouteGuard>
      <Outlet />
    </AdminRouteGuard>
  ),
})
